import { ReactNode, useMemo, useState } from 'react';
import { CardSummaryContext } from './CardSummaryContext';

/**
 * Holds the card-level AI summary in state above the entity form. Kept here — rather
 * than inside the form, which can unmount (e.g. when the chat sidebar takes over on
 * mobile) — so a generated summary survives while the card stays open and is lost only
 * on refresh or when leaving the card.
 */
export function CardSummaryProvider({ children }: { children: ReactNode }) {
  const [summary, setSummary] = useState<string>();
  const value = useMemo(() => ({ summary, setSummary }), [summary]);
  return <CardSummaryContext.Provider value={value}>{children}</CardSummaryContext.Provider>;
}
